import React from "react";
import { Container } from "react-bootstrap";
import "./GreenStrip.css";
export default function GreenStrip({ heading }) {
  return (
    <div className="green-strip-wrapper">
      <Container>
        <h1 className="heading">{heading}</h1>
      </Container>
    </div>
  );
}
